const TokenKey = 'user-Token'

/**
 * 获取 Token
 * @returns {string|null}
 */
export function getToken() {
    return localStorage.getItem(TokenKey)
}

/**
 * 设置 Token
 * @param {string} token
 * @returns {void}
 */
export function setToken(token) {
    return localStorage.setItem(TokenKey, token)
}

/**
 * 移除 Token
 * @returns {void}
 */
export function removeToken() {
    return localStorage.removeItem(TokenKey)
}
